export function isCurrencyUnit(unit) {
    const allowedCurrencyUnits = ['$', '€', 'USD', 'EUR']
    return allowedCurrencyUnits.includes(unit)
}
